module.exports = __webpack_public_path__ + "static/burger-80e02d7d15de744b052d33c4ee6048a8.png";